import { WithCustomAccuracyWeights } from './feature/ontologyFeatureTypings'
import { useCreateOntologyFeature } from './feature/useCreateOntologyFeature'
import { useDeleteOntologyFeature } from './feature/useDeleteOntologyFeature'
import { useEditOntologyFeature } from './feature/useEditOntologyFeature'
import { useOntologyFeatureById } from './feature/useGetOntologyFeatureById'
import { useCreateOntologyPredictionCorrection } from './predictionCorrection/useCreateOntologyPredictionCorrection'
import { useDeleteOntologyPredictionCorrection } from './predictionCorrection/useDeleteOntologyPredictionCorrection'
import { useEditOntologyPredictionCorrection } from './predictionCorrection/useEditOntologyPredictionCorrection'
import { useEditOntologyPredictionCorrectionCriticalErrors } from './predictionCorrection/useEditOntologyPredictionCorrectionCriticalErrors'
import { useGetOntologyPredictionCorrectionById } from './predictionCorrection/useGetOntologyPredictionCorrectionById'
import { useGetOntologyPredictionCorrectionCriticalErrors } from './predictionCorrection/useGetOntologyPredictionCorrectionCriticalErrors'
import { useGetCurrentProgramOntologyConfig } from './useGetCurrentProgramOntologyConfig'
import { useGetDisplayOntology } from './useGetDisplayOntology'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const WithCustomAccuracyWeightsType: WithCustomAccuracyWeights = undefined as any

export const ontology = {
  getCurrentProgramOntologyConfig: useGetCurrentProgramOntologyConfig,
  getDisplayOntology: useGetDisplayOntology,
  feature: {
    create: useCreateOntologyFeature,
    edit: useEditOntologyFeature,
    getById: useOntologyFeatureById,
    delete: useDeleteOntologyFeature,
    types: {
      WithCustomAccuracyWeightsType,
    },
  },
  predictionCorrection: {
    create: useCreateOntologyPredictionCorrection,
    edit: useEditOntologyPredictionCorrection,
    getById: useGetOntologyPredictionCorrectionById,
    delete: useDeleteOntologyPredictionCorrection,
    getCriticalErrors: useGetOntologyPredictionCorrectionCriticalErrors,
    editCriticalErrors: useEditOntologyPredictionCorrectionCriticalErrors,
  },
}
